<template>
  <div class="usr-downloadlist">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户中心</el-breadcrumb-item>
      <el-breadcrumb-item>已下载数据列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item  label="数据类别">
          <el-select  size="mini" v-model="searchParams.type" style="width:200px;" 
                      filterable placeholder="Proposal/GRB/SEM" clearable >
                  <el-option
                      v-for="item in filedataltype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="数据 ID">
          <el-input size="mini" style="width: 200px"  v-model="searchParams.ogs_id" clearable ></el-input>
        </el-form-item> 
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini' type="primary" @click="summary">统计</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="id"
          label="id"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类别">
        </el-table-column>
        <el-table-column
          prop="ogs_id"
          label="数据ID">
        </el-table-column>
        <el-table-column
          prop="level"
          label="数据级别">
        </el-table-column>
        <el-table-column
          prop="file_id"
          label="文件ID">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮件地址">
        </el-table-column>
        <el-table-column
          prop="user_id"
          label="用户ID">
        </el-table-column>
        <el-table-column
          prop="firsttime"
          label="首次下载时间">
        </el-table-column>
        <el-table-column
          prop="lasttime"
          label="末次下载时间">
        </el-table-column>
        <el-table-column
          prop="mintimelength"
          label="最短一次持续时间"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="maxtimelength"
          label="最长一次持续时间"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="minspeed"
          label="最慢一次平均速度"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="maxspeed"
          label="最快一次平均速度"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="repeat"
          label="重复下载次数">
        </el-table-column>
        <el-table-column
          prop="failure"
          label="未完成下载的次数"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="urls"
          label="申请URL次数">
        </el-table-column>
    
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {downfiletype} from '../common';
import axios from 'axios';

export default {
  name: 'Usrdownloadlist',
  data() {
    return {
      searchParams: {
        ogs_id: '',
        type: '',
      },
      list:[],
      filedataltype: downfiletype,
      currentPage: 1,
      pageSize: 20,
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/getUsrDownloadsummyData', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
      // console.log("authstates",this.currentastates);
    },
    summary() {
      const params = {
   
      };
      axios.post('/iapi/summary', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('统计完成');
        }else{
          this.$message('数据错误');
        }
      });
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },

  },
};
</script>

<style scoped>
.usr-downloadlist {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>